import { AssetDto, AssetVersionDto } from '@nusign/picflow-backend-types';

export const isImagesBucketAsset = (asset: AssetDto, version: AssetVersionDto): boolean => {
  if (!asset) return false;
  if (asset.type !== 'image') return false;
  if (version.original_key.includes('/base/')) return true; // the backend returns the base image in the original_key for images that are watermarked
  return version.original_key.startsWith('original/');
};
